module.exports = __webpack_public_path__ + "static/media/SmartPhoneShoppers.afc4871d.svg";